import type React from "react";

export const HIITIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  const { width = 50, height = 50, color = "#6a33ff", ...restProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...restProps}
    >
      <title>HIIT Icon</title>
      {/* Lightning bolt inside a split stopwatch */}
      <path d="M12 2v2M5 5l1.5 1.5M19 5l-1.5 1.5M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z" />
      <path
        d="M13 7l-3 4.5h4L11 17"
        fill="none"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};
